"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCounterColor = void 0;
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const getCounterColor = ({ color, shade }) => (shade ? (0, wl_ui_kit_1.getColorShade)(color, shade) : (0, wl_ui_kit_1.getColor)(color));
exports.getCounterColor = getCounterColor;
